import {Component, EventEmitter, OnInit, Output} from "@angular/core";
import {IMyDrpOptions} from "mydaterangepicker";
/**
 * Created by alex.y on 9/20/2017.
 */


@Component({
    selector: "date-range-selector",
    templateUrl: "./dateRangeSelector.component.html",
    moduleId: module.id.toString()
})
export class DateRangeSelectorComponent implements OnInit {
    @Output()
    public dateChange: EventEmitter<Object> = new EventEmitter();

    public myDateRangePickerOptions: IMyDrpOptions = {
        dateFormat: 'dd-mmm-yyyy',
    };

    public dateRangeModel: Object = {};

    public ngOnInit(): void {
        this.setCurrentLocalDate();
    }

    private setCurrentLocalDate(): void {
        let beginDate: Date = new Date((new Date()).setDate(new Date().getDate() - 7));
        let endDate = new Date();

        this.dateRangeModel['beginDate'] = {
            year: beginDate.getFullYear(),
            month: beginDate.getMonth() + 1,
            day: beginDate.getDate()
        };
        this.dateRangeModel['endDate'] = {
            year: endDate.getFullYear(),
            month: endDate.getMonth() + 1,
            day: endDate.getDate()
        };
    }

    public onDateChangeHandler(): void {
        if (this.dateRangeModel == null) {
            this.dateRangeModel = {};
            this.setCurrentLocalDate();
        }

        this.dateChange.emit(this.dateRangeModel);
    }

    public getCurrentDateModel(): Object {
        return this.dateRangeModel;
    }
}


// WEBPACK FOOTER //
// ./app/components/reports/filterSelectors/dateSelector/dateRangeSelector.component.ts